import TldlLandingCard from './TldlLandingCard';

export default TldlLandingCard;
